
define('text!templates/parts/chart/chart-line.html',[],function () { return '<div class="chart-line">\n    <div class="chart-canvas"><canvas></canvas></div>\n</div>\n';});

